import { useEffect, useState } from 'react'
import { buildStudentLabel } from '@helpers/students'

const useSortAndLabelStudentList = (items) => {
  const [students, setStudents] = useState([])
  const [studentOptions, setStudentOptions] = useState([])

  useEffect(() => {
    if (Array.isArray(items)) {
      const sortedItems = items.sort((a, b) => {
        let itemAString =
          a?.first_name && a?.last_name
            ? (a.first_name + a.last_name).toLowerCase()
            : a.username

        let itemBString =
          b?.first_name && b?.last_name
            ? (b.first_name + b.last_name).toLowerCase()
            : b.username

        return (itemAString > itemBString && 1) || -1
      })

      const labelledItems = sortedItems.map((a) => ({
        item: { ...a },
        label: buildStudentLabel(a, items),
      }))

      setStudents(labelledItems)
    }
  }, [items])

  useEffect(() => {
    if (Array.isArray(students)) {
      setStudentOptions(
        students.map((student) => ({
          name: student.label,
          value: student.item.id,
          item: student.item,
        }))
      )
    }
  }, [students])

  return {
    students,
    studentOptions,
  }
}

export { useSortAndLabelStudentList }
